module.exports = __webpack_public_path__ + "type.8bdd6252.png";